/**
 * Capture the anonymous session key before login/signup to survive session rotation.
 *
 * Django rotates session keys at login for security. This function captures the
 * pre-login session key in an httpOnly cookie that survives the rotation, allowing
 * the server to find and merge the anonymous cart.
 *
 * @returns {Promise<void>}
 */
export const capturePreloginSession = async () => {
  try {
    const response = await fetch('/api/store/cart/capture-session/', {
      method: 'POST',
      credentials: 'include', // Important: sends/receives cookies
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.ok) {
      const data = await response.json();
      console.log('[CartCapture] Pre-login session captured:', {
        session_key: data.session_key?.slice(0, 8) + '...',
        cart_id: data.cart_id,
        item_count: data.item_count,
      });
    } else {
      console.warn('[CartCapture] Failed to capture session:', response.status);
    }
  } catch (error) {
    // Don't throw - this is non-critical. If it fails, merge will fall back to current session.
    console.error('[CartCapture] Error capturing pre-login session:', error.message);
  }
};
